<script lang="ts">
  import Spinner from "./Spinner.svelte";

  export let primary = false;
  export let secondary = false;
  export let text = false;
  export let isBusy = false;
  export let isLink = false;

  let clazz = "";
  let buttonElement: HTMLButtonElement | HTMLAnchorElement;
  export { clazz as class };
  export function scrollIntoView() {
    if (buttonElement) {
      buttonElement.scrollIntoView({ behavior: "smooth" });
    }
  }

  $: element = isLink ? "a" : "button";
</script>

<svelte:element
  this={element}
  bind:this={buttonElement}
  role="button"
  tabindex="0"
  class:primary
  class:secondary
  class:text
  class:busy={isBusy}
  class={`flex ${clazz || ""}`}
  {...$$restProps}
  on:click>
  {#if isBusy}
    <Spinner class="text-black w-6 h-6" />
  {:else}
    <slot name="icon"></slot>
  {/if}
  <div class="flex grow justify-center"><slot /></div>
</svelte:element>

<style>
  button,
  a {
    box-sizing: border-box;
    height: var(--button-height);
    padding: var(--button-padding);
    justify-content: var(--button-justify-content);
    align-items: var(--button-align-items);
    gap: var(--button-gap);
    border-radius: var(--button-border-radius);
    color: var(--button-color);
    border: 3px solid transparent;
    font-weight: var(--button-font-weight);
  }

  button:disabled,
  button[disabled]:hover,
  a.disabled,
  a.disabled:hover {
    background-color: var(--button-disabled-background);
    color: var(--button-disabled-color);
  }

  button :global(path),
  a :global(path) {
    fill: var(--button-color);
  }

  button:disabled :global(path),
  a.disabled :global(path) {
    fill: var(--button-disabled-color);
  }

  a.disabled :global(img),
  button:disabled :global(img) {
    opacity: 0.4;
  }

  button:hover,
  button:focus,
  :focus-visible,
  a:hover,
  a:focus {
    outline: none;
    border: 3px solid transparent;
  }

  .primary {
    background-color: var(--primary-button-background);
  }

  .primary:hover {
    background-color: var(--primary-button-hover-background);
  }

  .primary:focus {
    background-color: var(--primary-button-focus-background);
    border: 3px solid var(--primary-button-focus-border-color);
  }

  .secondary {
    background-color: var(--secondary-button-background);
  }

  .secondary:hover {
    background-color: var(--secondary-button-hover-background);
  }

  .secondary:focus {
    background-color: var(--secondary-button-focus-background);
    border: 3px solid var(--secondary-button-focus-border-color);
  }

  .text {
    padding: 0%;
  }

  .text:active,
  .text:hover {
    color: var(--fooji-blue-100);
  }

  .text:disabled,
  .text:disabled:hover {
    color: var(--button-disabled-color);
    background: none;
  }

  .primary:disabled,
  .primary:disabled:hover {
    background: var(--button-disabled-background);
  }
</style>
